import React from 'react';

const IllustrationComponent = ({ name }) => {
  const image = window.Jbhifi?.Receipts?.Images[name];

  return image?.x1 ? (
    <div className="illustration-container">
      <img className="illustration" src={image.x1} srcSet={`${image.x1} 1x, ${image.x2} 2x, ${image.x3} 3x`} alt="" />
    </div>
  ) : null;
};

export default IllustrationComponent;
